import { render, staticRenderFns } from "./manage-backlog.vue?vue&type=template&id=e7bc581e&"
import script from "./manage-backlog.vue?vue&type=script&lang=js&"
export * from "./manage-backlog.vue?vue&type=script&lang=js&"
import style0 from "./manage-backlog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports